import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

import { formatCompact } from '@shared/utils/dateUtils';

import { getLabel } from '@shared/utils';
import { getTransactionCommissionReport } from '@shared/services/api/commissionsService';

const useStyles = makeStyles({
  row: {
    fontSize: '19px',
    textAlign: 'left',
    letterSpacing: '0px',
    opacity: '1',
    paddingLeft: '5px',
    paddingRight: '5px',
  },
});

interface Transaction {
  [key: number]: any;
}

interface SummaryCardProps {
  searchFilter: {
    df: string;
    dt: string;
    crsp?: string;
  };
}

const SummaryCard: React.FC<SummaryCardProps> = ({ searchFilter }) => {
  const classes:any = useStyles();
  const [total, setTotal] = useState<number>(0);
  const [summary, setSummary] = useState<{ name: string; amount: number; commission: string }[]>([
    {
      name: 'Depósito',
      amount: 0,
      commission: '0',
    },
    {
      name: 'Retiro',
      amount: 0,
      commission: '0',
    },
  ]);

  const getAmount = (transactionsList: Transaction[]) => {
    transactionsList = Object.keys(transactionsList).length === 0 ? [] : transactionsList;
    const deposits = transactionsList.filter((transaction) => transaction[4] === 5);
    const withdrawals = transactionsList.filter((transaction) => transaction[4] === 2);
    let totalDeposits = 0;
    deposits.forEach((deposit) => {
      totalDeposits += deposit[6];
    });
    let totalWidthdraw = 0;
    withdrawals.forEach((withdraw) => {
      totalWidthdraw += withdraw[6];
    });
    setSummary([
      {
        name: 'Depósito',
        amount: deposits.length,
        commission: totalDeposits.toFixed(2),
      },
      {
        name: 'Retiro',
        amount: withdrawals.length,
        commission: totalWidthdraw.toFixed(2),
      },
    ]);
    setTotal(parseFloat((totalDeposits + totalWidthdraw).toFixed(2)));
  };

  const syncReport = async () => {
    const { df, dt, crsp } = searchFilter;
    const search: { df: string; dt: string; crsp?: string } = {
      df: formatCompact(df),
      dt: formatCompact(dt),
    };
    if (crsp) {
      search.crsp = crsp;
    }
    const response = await getTransactionCommissionReport(search);
    const { data } = response?.data || [];
    getAmount(data.content);
  };

  useEffect(() => {
    syncReport();
  }, [searchFilter]);

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} size="small" aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>{getLabel('operationType')}</TableCell>
            <TableCell align="right">{getLabel('count')}</TableCell>
            <TableCell align="right">{getLabel('commission')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {summary.map((row) => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.amount}</TableCell>
              <TableCell align="right">{row.commission}</TableCell>
            </TableRow>
          ))}
          <TableCell colSpan={2} align="right">
            {getLabel('total')}
          </TableCell>
          <TableCell align="right">{total}</TableCell>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SummaryCard;
